const p=["jpg","jpeg","png"];export{p as IMAGE_FILE_KAKAOTALK};
//# sourceMappingURL=fileTypesKakaoTalk.js.map
